/** Uppercases the first character using the casing rules of `locale`. */
export function capitalizeFirstLetter(
  value: string,
  locale?: string | string[]
): string {
  return value.charAt(0).toLocaleUpperCase(locale) + value.slice(1);
}
